import { useState, useEffect } from 'react';
import { useIsMobile } from '../hooks/useIsMobile';

const START_KEY = 'mr_hire_start';
const LAST_KEY = 'mr_hire_last';
const RESET_MS = 15 * 60 * 1000;

function readStart() {
  const now = Date.now();
  let start = parseInt(localStorage.getItem(START_KEY) || '0', 10);
  const last = parseInt(localStorage.getItem(LAST_KEY) || '0', 10);
  if (!start || (last && now - last > RESET_MS)) {
    start = now;
    localStorage.setItem(START_KEY, String(start));
  }
  localStorage.setItem(LAST_KEY, String(now));
  return start;
}

function fmt(ms) {
  const s = Math.floor(ms / 1000);
  const h = String(Math.floor(s / 3600)).padStart(2, '0');
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
  const sc = String(s % 60).padStart(2, '0');
  return `${h}:${m}:${sc}`;
}

export default function HireTimer({ label = "Still hasn't hired Makayla" }) {
  const isMobile = useIsMobile();
  const [start] = useState(() => {
    try { return readStart(); } catch (e) { return Date.now(); }
  });
  const [now, setNow] = useState(Date.now());
  const [shrunk, setShrunk] = useState(false);

  useEffect(() => {
    const t = setInterval(() => {
      setNow(Date.now());
      try { localStorage.setItem(LAST_KEY, String(Date.now())); } catch (e) {}
    }, 1000);
    const save = () => { try { localStorage.setItem(LAST_KEY, String(Date.now())); } catch (e) {} };
    window.addEventListener('beforeunload', save);
    return () => { clearInterval(t); window.removeEventListener('beforeunload', save); };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setShrunk(true), 4000);
    return () => clearTimeout(t);
  }, []);

  if (isMobile) return null;

  return (
    <div
      className="no-print"
      title="The clock's running. Just saying."
      style={{
        position: 'fixed', bottom: 16, right: 16, zIndex: 250,
        background: 'linear-gradient(135deg, var(--ink), var(--plum))',
        color: 'white',
        borderRadius: shrunk ? 14 : 20,
        padding: shrunk ? '8px 14px' : '22px 32px',
        boxShadow: 'var(--shadow), 0 0 0 3px var(--blush)',
        display: 'flex', alignItems: 'center',
        gap: shrunk ? 10 : 16,
        fontFamily: "'Courier Prime', monospace", cursor: 'default',
        transition: 'padding 1.4s cubic-bezier(.4,0,.2,1), border-radius 1.4s cubic-bezier(.4,0,.2,1), gap 1.4s cubic-bezier(.4,0,.2,1)',
      }}
    >
      <span style={{
        fontSize: shrunk ? 14 : 32, opacity: 0.7,
        transition: 'font-size 1.4s cubic-bezier(.4,0,.2,1)',
      }}>⏱</span>
      <div style={{ lineHeight: 1.2 }}>
        <div style={{
          fontSize: shrunk ? 8 : 13, fontWeight: 800,
          letterSpacing: '.08em', textTransform: 'uppercase',
          color: 'var(--rose)',
          transition: 'font-size 1.4s cubic-bezier(.4,0,.2,1)',
        }}>{label}</div>
        <div style={{
          fontSize: shrunk ? 16 : 38, fontWeight: 700,
          letterSpacing: '.04em',
          transition: 'font-size 1.4s cubic-bezier(.4,0,.2,1)',
        }}>{fmt(now - start)}</div>
      </div>
    </div>
  );
}
